import {VehicleDataAcquisitionDocumentDto} from "../../api/vda";
import {LeadingLicensePlateType} from "../../components/page/vda/VdaForm";

const TYPE_ORDER = [
    "COR_I",
    "COR_II",
    "COC",
    "ABE",
    "LICENSE_PLATE_FRONT",
    "LICENSE_PLATE_REAR",
    "CAR_KEY",
    "CERT",
    "CONTRACT",
    "ID_CARD",
    "RADIO_CODE",
    "SALARY_STATEMENT",
    "WARRANTY",
    "OTHER",
].reverse()

export function sortDocuments(documents: VehicleDataAcquisitionDocumentDto[]) {
    return documents.sort((a, b) => {
        return TYPE_ORDER.indexOf(b.type) - TYPE_ORDER.indexOf(a.type)
    })
}

export function updateLicensePlates(documents: VehicleDataAcquisitionDocumentDto[], updated: boolean, {
        leadingLicensePlate,
        licensePlate
    }: {
        leadingLicensePlate: LeadingLicensePlateType | undefined;
        licensePlate: string;
    }): void {

    if (!updated) {
        return
    }

    documents.forEach(document => {
        if (leadingLicensePlate !== document.type && (document.type === 'COR_II' || document.type === 'LICENSE_PLATE_FRONT' || document.type === 'LICENSE_PLATE_REAR')) {
            document.licensePlate = licensePlate
        }
        if (document.type === 'CAR_KEY' && (document.note && (licensePlate.startsWith(document.note) || document.note?.startsWith(licensePlate)))) {
            document.note = licensePlate
        }
    })
}
